import { connect } from 'react-redux';

import { entitySelectors } from '@store/entity/selectors';
import { yourJourneySelectors } from '@store/yourJourney/selectors';

import { SpaDaysCategoryV2 } from './SpaDaysCategoryV2';

const mapStateToProps = (state) => ({
  property: entitySelectors.getProperty(state),
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
});

export const SpaDaysCategoryV2Connected = connect(mapStateToProps)(SpaDaysCategoryV2);
